import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReadyToStartProject from "../components/ReadyToStartProject";
import AOS from "aos";
import "aos/dist/aos.css"; // Importez les styles de AOS
import { Helmet } from "react-helmet";

const SiteVitrine = () => {
  const [showMore, setShowMore] = useState({});

  useEffect(() => {
    AOS.init({
      duration: 1000, // Durée de l'animation en ms
      easing: "ease-in-out", // Type d'animation
    });
  }, []);

  const toggleShowMore = (index) => {
    setShowMore((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const scrollToElement = (text) => {
    document.getElementById(text).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-gradient-to-b from-gray-900 to-gray-700 min-h-screen text-white">
      <Helmet>
        <title>Site Vitrine Professionnel | WebMinds</title>
        <meta
          name="description"
          content="Créez une vitrine en ligne professionnelle avec WebMinds. Découvrez nos services de création de site vitrine, incluant la conception personnalisée, l'intégration de formulaires et l'optimisation SEO."
        />
        <meta
          name="keywords"
          content="site vitrine, création de site web, conception de site vitrine, services web, optimisation SEO, site internet professionnel"
        />
        <meta
          property="og:title"
          content="Site Vitrine Professionnel | WebMinds"
        />
        <meta
          property="og:description"
          content="Créez une vitrine en ligne professionnelle avec WebMinds. Découvrez nos services de création de site vitrine, incluant la conception personnalisée, l'intégration de formulaires et l'optimisation SEO."
        />
        <meta property="og:image" content="%PUBLIC_URL%/images/vitrine.jpg" />

        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />
      <div
        className="h-screen bg-cover bg-center relative"
        style={{ backgroundImage: `url('/images/vitrine.jpg')` }}
        data-aos="fade-in"
      >
        <div className="flex items-center justify-center h-full bg-black bg-opacity-60">
          <div className="text-center max-w-3xl">
            <h1 className="text-5xl font-extrabold mb-6">
              Présentez Votre Entreprise au Monde
            </h1>
            <p className="text-2xl mb-6">
              Créez une vitrine en ligne professionnelle qui reflète l'image de
              votre entreprise et capte l'attention de vos visiteurs.
            </p>
            <p className="text-lg mb-8">
              Mettez en avant vos services, vos réalisations et vos valeurs avec
              un site vitrine élégant et fonctionnel.
            </p>
            <a
              href="javascript:void(0)"
              onClick={() => scrollToElement("services")}
              className="mt-4 px-8 py-3 bg-blue-600 text-white text-lg font-semibold rounded-md shadow-lg hover:bg-blue-700 transition duration-300"
            >
              Découvrez nos services
            </a>
          </div>
        </div>
        <div
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white cursor-pointer animate-bounce"
          onClick={() => scrollToElement("services")}
        >
          <i className="fas fa-chevron-down fa-2x"></i>
        </div>
      </div>

      {/* Section Pourquoi un Site Vitrine */}
      <div
        id="services"
        className="py-16 px-6 md:px-12 lg:px-24 bg-gray-800"
        data-aos="fade-up"
      >
        <h2 className="text-4xl font-bold mb-8 text-center">
          Pourquoi Choisir un Site Vitrine ?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          <div data-aos="fade-up" data-aos-delay="100">
            <h3 className="text-2xl font-semibold mb-4">
              Valorisation de Votre Marque
            </h3>
            <p className="text-lg mb-4">
              Un site vitrine met en avant votre identité visuelle et votre
              expertise, renforçant ainsi votre marque auprès de vos clients.
            </p>
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
            <h3 className="text-2xl font-semibold mb-4">
              Présentation de Vos Services
            </h3>
            <p className="text-lg mb-4">
              Mettez en avant vos offres et services de manière claire et
              attrayante pour attirer et convaincre vos prospects.
            </p>
          </div>
          <div data-aos="fade-up" data-aos-delay="300">
            <h3 className="text-2xl font-semibold mb-4">Contact Facile</h3>
            <p className="text-lg mb-4">
              Facilitez la prise de contact avec un formulaire intuitif et des
              informations claires sur la façon de vous joindre.
            </p>
          </div>
          <div data-aos="fade-up" data-aos-delay="400">
            <h3 className="text-2xl font-semibold mb-4">Référencement Local</h3>
            <p className="text-lg mb-4">
              Optimisez votre site pour le référencement local afin que vos
              clients potentiels vous trouvent facilement en ligne.
            </p>
          </div>
        </div>
      </div>

      <div className="py-16 bg-gray-900 px-6 md:px-12 lg:px-24">
        <h2 className="text-4xl font-bold mb-8 text-center text-yellow-500">
          Nos Services de Création de Site Vitrine
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Conception Personnalisée
            </h3>
            <p className="text-lg mb-4">
              Créez un site vitrine unique qui reflète parfaitement l'image et
              les valeurs de votre entreprise.
            </p>

            {/* Texte caché */}
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[0] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Ce service inclut une analyse approfondie de votre marque, des
                maquettes personnalisées et des révisions illimitées pour vous
                assurer que le design final correspond parfaitement à vos
                attentes.
              </p>
            </div>

            {/* Bouton Lire plus/Lire moins */}
            <button
              onClick={() => toggleShowMore(0)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[0] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Intégration de Formulaires de Contact
            </h3>
            <p className="text-lg mb-4">
              Offrez à vos visiteurs un moyen simple et direct de vous contacter
              avec des formulaires personnalisés.
            </p>

            {/* Texte caché */}
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[1] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Les formulaires peuvent être intégrés avec votre CRM pour une
                gestion simplifiée des leads, et sont entièrement
                personnalisables pour répondre à vos besoins spécifiques.
              </p>
            </div>

            {/* Bouton Lire plus/Lire moins */}
            <button
              onClick={() => toggleShowMore(1)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[1] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Optimisation pour Référencement
            </h3>
            <p className="text-lg mb-4">
              Améliorez la visibilité de votre site vitrine avec des stratégies
              SEO adaptées pour vous aider à mieux vous positionner sur les
              moteurs de recherche.
            </p>

            {/* Texte caché */}
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[2] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Nous utilisons les meilleures pratiques SEO, incluant la
                recherche de mots-clés, l'optimisation des balises, et la
                création de contenu optimisé pour améliorer votre classement.
              </p>
            </div>

            {/* Bouton Lire plus/Lire moins */}
            <button
              onClick={() => toggleShowMore(2)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[2] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          {/* Nouvelle carte 1 */}
          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Hébergement Sécurisé
            </h3>
            <p className="text-lg mb-4">
              Bénéficiez d'un hébergement sécurisé pour votre site vitrine avec
              des sauvegardes automatiques et une protection contre les
              attaques.
            </p>

            {/* Texte caché */}
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[3] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Notre service d'hébergement inclut des certificats SSL, un
                monitoring en temps réel, et un support technique disponible
                24/7 pour assurer la sécurité et la disponibilité de votre site.
              </p>
            </div>

            {/* Bouton Lire plus/Lire moins */}
            <button
              onClick={() => toggleShowMore(3)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[3] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          {/* Nouvelle carte 2 */}
          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Maintenance Continue
            </h3>
            <p className="text-lg mb-4">
              Assurez la pérennité de votre site avec notre service de
              maintenance continue qui comprend des mises à jour régulières et
              une surveillance proactive.
            </p>

            {/* Texte caché */}
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[4] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Notre équipe se charge des mises à jour de sécurité, de la
                correction des bugs, et de l'amélioration continue des
                performances de votre site pour garantir une expérience
                utilisateur optimale.
              </p>
            </div>

            {/* Bouton Lire plus/Lire moins */}
            <button
              onClick={() => toggleShowMore(4)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[4] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          {/* Nouvelle carte 3 */}
          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Analyse de Performance
            </h3>
            <p className="text-lg mb-4">
              Obtenez une analyse détaillée des performances de votre site pour
              identifier les points d'amélioration et optimiser l'expérience
              utilisateur.
            </p>

            {/* Texte caché */}
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[5] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Ce service inclut des rapports réguliers sur la vitesse de
                chargement, le taux de conversion, et les comportements des
                utilisateurs, avec des recommandations pour améliorer
                l'efficacité de votre site.
              </p>
            </div>

            {/* Bouton Lire plus/Lire moins */}
            <button
              onClick={() => toggleShowMore(5)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[5] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>
        </div>
      </div>

      {/* Section des Tarifs Site Vitrine */}
      <section
        id="pricing"
        className="py-20 bg-fixed bg-cover bg-center text-center"
        style={{
          backgroundImage: `url('/images/bg-pricing.jpg')`,
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
        }}
        data-aos="fade-up"
      >
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 py-16">
          <h2 className="text-5xl font-bold mb-16 text-yellow-400">
            Nos Tarifs Site Vitrine
          </h2>
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
            {/* Plan de Base */}
            <div
              className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-blue-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col"
              data-aos="fade-up"
            >
              <div className="absolute top-0 left-0 bg-blue-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Populaire
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait de Base
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">599€</p>
              <ul className="text-left space-y-4">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Conception de site vitrine de base
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Intégration de formulaire de contact
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Formation à la gestion du site
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-blue-500 text-white font-semibold rounded-md shadow-lg hover:bg-blue-600 transition duration-300"
              >
                Commencer
              </a>
            </div>
            {/* Plan Avancé */}
            <div
              className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-yellow-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="absolute top-0 left-0 bg-yellow-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Le Plus Populaire
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait Avancé
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">899€</p>
              <ul className="text-left space-y-4 mb-5">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Conception complète de site vitrine
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Optimisation SEO de base
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Support technique pendant 6 mois
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-yellow-500 text-white font-semibold rounded-md shadow-lg hover:bg-yellow-600 transition duration-300"
              >
                Commencer
              </a>
            </div>
            {/* Plan Pro */}
            <div
              className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-red-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="absolute top-0 left-0 bg-red-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Exclusif
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait Pro
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">1199€ +</p>
              <ul className="text-left space-y-4">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Conception vitrine sur mesure
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Optimisation SEO avancée
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Maintenance et support pendant 1 an
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2 mb-10"></i>
                  Hébergement sécurisé inclus
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-red-500 text-white font-semibold rounded-md shadow-lg hover:bg-red-600 transition duration-300"
              >
                Commencer
              </a>
            </div>
          </div>
          <p className="mt-10 text-gray-400 text-center">
            Les tarifs indiqués sont standards et peuvent varier en fonction de
            vos besoins spécifiques. N’hésitez pas à nous contacter pour un
            devis personnalisé.
          </p>
        </div>
      </section>
      <ReadyToStartProject />
      <Footer />
    </div>
  );
};

export default SiteVitrine;
